import {
    GET_DEPARTMETMAP_ALL,
    GET_ALL_UNIT_REVIEWER,
    UPDATE_DEPARTMETMAP_MODAL,
    ERROR_DEPARTMENTMAP_FAIL,
    DEPARTMETMAP_SUCCESS,

    UPDATE_UNIT_REVIEWER_MODAL,
    ERROR_UNIT_REVIEWER_FAIL,
    UNIT_REVIEWER_SUCCESS
} 
from '../actions/actionTypes';

const initialState = {
    departmapAll: [],
    unitreviewerAll: [],
    departmapModal: {},
    isSuccess: true,
    departmaperrorMsg: "",
    unitReviewerIsSuccess: true,
    departmanageModal: {},
    departmanageErrorMsg: "",
};

function DepartmentMapRedux(state = initialState, action) {
    switch (action.type) {
        case GET_DEPARTMETMAP_ALL:
            return {
                ...state,
                departmapAll: action.payload
            };
        case GET_ALL_UNIT_REVIEWER:
            return {
                ...state,
                unitreviewerAll: action.payload
            };
        case UPDATE_DEPARTMETMAP_MODAL:
            return {
                ...state,
                departmapModal: action.data
            };
        case ERROR_DEPARTMENTMAP_FAIL:
            return {
                ...state,
                departmaperrorMsg: action.payload,
                isSuccess: false
            };
        case DEPARTMETMAP_SUCCESS:
            return {
                ...state,
                isSuccess: true
            };
        case UPDATE_UNIT_REVIEWER_MODAL:
            return {
                ...state,
                departmanageModal: action.data
            };
        case ERROR_UNIT_REVIEWER_FAIL:
            return {
                ...state,
                departmanageErrorMsg: action.payload,
                unitReviewerIsSuccess: false
            };
        case UNIT_REVIEWER_SUCCESS:
            return {
                ...state,
                unitReviewerIsSuccess: true
            };
        default:
            return state;
    }
}

export default DepartmentMapRedux;